/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Tag",
  size: 20
}

const SvgTag = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path
      fill="none"
      strokeWidth={1.1}
      d="M17.5 3.71v4.01c0 .24-.1.48-.29.67L8.39 17.2c-.4.4-1.06.4-1.46 0L2.8 13.07c-.4-.4-.4-1.06 0-1.46l8.81-8.81c.2-.2.47-.3.73-.3h3.85c.33 0 .67.13.92.38.24.23.37.52.39.83h0z"
    />
    <circle cx={14} cy={6} r={1} />
  </Svg>
)

SvgTag.defaultProps = defaultProps
export default SvgTag
